(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patient-type', {
            parent: 'entity',
            url: '/patient-type',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Patient Types'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-type/patient-types.html',
                    controller: 'PatientTypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('patient-type-detail', {
            parent: 'entity',
            url: '/patient-type/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'PatientType'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-type/patient-type-detail.html',
                    controller: 'PatientTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PatientType', function($stateParams, PatientType) {
                    return PatientType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'patient-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('patient-type-detail.edit', {
            parent: 'patient-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-type/patient-type-dialog.html',
                    controller: 'PatientTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientType', function(PatientType) {
                            return PatientType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-type.new', {
            parent: 'patient-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-type/patient-type-dialog.html',
                    controller: 'PatientTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patient-type', null, { reload: 'patient-type' });
                }, function() {
                    $state.go('patient-type');
                });
            }]
        })
        .state('patient-type.edit', {
            parent: 'patient-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-type/patient-type-dialog.html',
                    controller: 'PatientTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientType', function(PatientType) {
                            return PatientType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-type', null, { reload: 'patient-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-type.delete', {
            parent: 'patient-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-type/patient-type-delete-dialog.html',
                    controller: 'PatientTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatientType', function(PatientType) {
                            return PatientType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-type', null, { reload: 'patient-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
